import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c5003bae&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=c5003bae&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=c5003bae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5003bae",
  null
  
)

export default component.exports